import { SharedModel } from '../sharedmodel';
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { IntegrationRuntime } from './integrationRuntime';
import { LinkedService } from '../linkedservice/linkedservice';
import { Credential } from '../credential/credential';
import { ManagedVirtualNetwork } from '../managedvirtualnetwork/managedVirtualNetwork';
import { irTypesConst, ILinkedDataFactoryContract } from '../../integrationruntime/integrationruntime.constants';
import { shellStringResources as stringResources } from '../../Resources/ShellStringResources';
import { AzureStorageLinkedService } from '../linkedservice/azure-storage.linkedservice';
import { ComputeType } from '../dataflow/interfaces';
import { ExpressCustomSetup } from '../expressCustomSetup/expressCustomSetup';
import { PackageStore } from '../packageStore/packageStore';
import { SelfHostedIntegrationRuntime } from './selfhosted.integrationRuntime';

@Metamodel.model({
    name: irTypesConst.Managed
})
export class ManagedIntegrationRuntime extends IntegrationRuntime {
    public static readonly MODEL: IModel;

    public computeLocation?: string;
    public computeNodeSize?: string;
    @Metamodel.attribute({
        display: stringResources.IR_ComputeNodes,
        constraint: {
            whole: true,
            minimum: 1
        }
    })
    public computeNumberOfNodes?: number;
    @Metamodel.attribute({
        display: stringResources.IR_ParallelExecutionPerNode,
        constraint: {
            whole: true,
            minimum: 1
        }
    })
    public computeMaxParallelExecutionsPerNode?: number;

    @Metamodel.attribute({
        display: stringResources.UseSparkGateway
    })
    public useSparkGateway?: boolean = false;

    @Metamodel.attribute({
        display: stringResources.DataFlowComputeTypeLabel,
        constraint: {
            required: true
        }
    })
    public dataFlowComputeType?: ComputeType = 'General';

    @Metamodel.attribute({
        display: stringResources.DataFlowCoreCountLabel,
        constraint: {
            required: true,
            minimum: 8,
            whole: true
        }
    })
    public dataFlowCoreCount?: number = 8;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_TimeToLive,
        constraint: {
            required: true,
            minimum: 0,
            whole: true
        }
    })
    public dataFlowTimeToLive?: number = 0;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_TimeToLive,
        constraint: {
            minimum: 0,
            whole: true
        }
    })
    public dataFlowTimeToLiveInMinutes?: number = 0;

    @Metamodel.attribute({
        display: stringResources.DataFlowCleanupLabel
    })
    public dataFlowCleanup?: boolean;

    @Metamodel.attribute({
        display: stringResources.DataBricks_ExternalComputeInformation
    })
    public externalComputeInfo?: SharedModel.DataFlowExternalComputeProperties[];

    public customProperties?: SharedModel.ICustomProperty[];

    @Metamodel.attribute({
        type: ManagedVirtualNetwork.MODEL,
        reference: true
    })
    public managedVirtualNetwork?: ManagedVirtualNetwork;

    @Metamodel.attribute({
        type: Credential.MODEL,
        reference: true,
        constraint: {
            unique: true
        }
    })
    public credential?: Credential;

    public copyComputeScaleEnabled?: boolean;
    public hasPipelineExternalProperty?: boolean;

    @Metamodel.attribute({
        display: stringResources.DataIntegrationUnitLabel
    })
    public copyComputeScaleDataIntegrationUnit?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_TimeToLive
    })
    public copyComputeScaleTimeToLive?: number;

    @Metamodel.attribute({
        display: stringResources.ModelName_HdiOnDemand_TimeToLive
    })
    public pipelineExternalComputeScaleTimeToLive?: number;

    public numberOfPipelineNodes?: number;
    public numberOfExternalNodes?: number;

    public computeVNetId?: string;
    public computeSubnet?: string;

    public computeSubnetResourceId?: string;

    public publicIPs?: string[];
    public ssisCatalogServerEndpoint?: string;
    public ssisCatalogAdminUsername?: string;
    public ssisCatalogAdminPassword?: string;
    public ssisCatalogPricingTier?: string;
    public dualStandbyPairName?: string;
    public licenseType?: string;

    public ssisCustomSetupContainerSasUri?: string;
    public skuSetting?: string;
    public runtimeVersion?: string;

    @Metamodel.attribute({
        type: SelfHostedIntegrationRuntime.MODEL,
        reference: true,
        constraint: {
            unique: true
        }
    })
    public ssisSelfHostedIR?: IntegrationRuntime;

    @Metamodel.attribute({
        type: AzureStorageLinkedService.MODEL,
        reference: true,
        constraint: {
            unique: true
        }
    })
    public ssisBlobLinkedService?: AzureStorageLinkedService;
    public ssisStoragePath?: string;

    public ssisCustomSetups?: ExpressCustomSetup[];
    public packageStores?: PackageStore[];
    public linkedAzureSsisIrResourceIds?: string[];

    // following entities are not in the payload
    public sqlSubscription?: string;
    public vnetSubscription?: string;
    public sqlId?: string;
    public requiredJoinVnet?: boolean;
    public requiredAllowAllAzureAccess?: boolean;
    public requiredTestConnection?: boolean;
    public requiredTierOptions?: boolean;
    public requiredServerDescriptionText?: boolean;
    public joinVnetAllowed?: boolean;
    public bringIpAllowed?: boolean;
    public sqlLocation?: string;
    public vNetLocation?: string;
    public vNetType?: string;
    public useAADAuth?: boolean;
    public useUAMIAuth?: boolean;
    public useSelfHostIr?: boolean;
    public useSharingSsisIr?: boolean;
    public useSSISDB?: boolean;
    public useNonCustomSetup?: boolean;
    public usePackageStore?: boolean;
    public selectedPackageStoreName?: string;
    public useIRDualStandbyPair?: boolean;
    public useVNetV2?: boolean;
    public linkedService?: LinkedService;
    public sharingDataFactories?: ILinkedDataFactoryContract[];
    public sharedIROrigianlResourceId?: string;
    public sharedIntegrationRuntimeLocation?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
